import React from "react";
import { Container, Stack } from "@mui/material";
import { MiContenidoPageHeader } from "../components/profile/MiContenidoPageHeader";
import {
  MiContenidoEntityBreadcrumbs,
  miContenidoPerfilBreadcrumb,
} from "./MiContenidoEntityBreadcrumbs";

export type MiContenidoSubpageShellProps = {
  /** Defaults to back link to Mi contenido profile. */
  aboveTitle?: React.ReactNode;
  /** Optional logo/avatar next to the title (e.g. program detail). */
  identity?: React.ReactNode;
  title: React.ReactNode;
  belowTitle?: React.ReactNode;
  actions: React.ReactNode;
  children: React.ReactNode;
};

const defaultAboveTitle = (
  <MiContenidoEntityBreadcrumbs segments={[miContenidoPerfilBreadcrumb()]} />
);

/**
 * Standard Mi contenido subpage layout: container, back to profile, header row, body slot.
 */
export const MiContenidoSubpageShell: React.FC<
  MiContenidoSubpageShellProps
> = ({ aboveTitle, identity, title, belowTitle, actions, children }) => (
  <Container maxWidth="xl">
    <Stack spacing={1}>
      <MiContenidoPageHeader
        aboveTitle={aboveTitle ?? defaultAboveTitle}
        identity={identity ?? null}
        title={title}
        belowTitle={belowTitle}
        actions={actions}
      />
      {children}
    </Stack>
  </Container>
);
